export default "__VITE_ASSET__BIkbrKd8__"